import { type ReactNode, createContext, useContext, useEffect, useState } from 'react';

import { useGetCart } from '~/hooks/useCart';
import { type Cart, emptyCart } from '~/types/cart';

type DrawerContextValue = {
  cart: Cart;
  cartOpen: boolean;
  setCartOpen: (open: boolean) => void;
};

const DrawerContext = createContext<DrawerContextValue | undefined>(undefined);

export function DrawerProvider({ children }: { children: ReactNode }) {
  const [cart, setCart] = useState<Cart>(emptyCart);
  const [cartOpen, setCartOpen] = useState(false);
  const { data: newCart } = useGetCart();
  useEffect(() => {
    if (newCart) setCart(newCart);
  }, [newCart]);

  return (
    <DrawerContext.Provider
      value={{
        cart,
        cartOpen,
        setCartOpen,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}

export const useCartContext = () => {
  const context = useContext(DrawerContext);
  if (!context) throw new Error('useDrawer must be used within DrawerProvider');
  return context;
};
